import React, { Component, useRef, useState, useEffect } from 'react';
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';

import NavMenu from './NavMenu';
import * as utils from './Utils.js'

const hotels = [
  {
    name: "Newport Marriott Hotel",
    price: "424",
    groupRate: true,
    links: {
      booking: "https://www.marriott.com/event-reservations/reservation-link.mi?id=1744987074454&key=GRP&guestreslink2=true&app=resvlink",
      website: "https://www.marriott.com/en-us/hotels/pvdlw-newport-marriott-hotel-and-spa"
    },
    distances: [
      {
        name: "Gardiner House",
        car: "5min",
        walking: "17min"
      },
      {
        name: "St. Mary's Church",
        car: "5min",
        walking: "14min"
      },
      {
        name: "Castle Hill Inn",
        car: "14min"
      },
      {
        name: "Downtown",
        walking: "5min"
      }
    ]
  },
  {
    name: "Newport Harbor Hotel",
    price: "339",
    groupRate: true,
    links: {
      booking: "https://reservations.travelclick.com/17382?groupID=4741193",
      website: "https://www.newporthotel.com"
    },
    distances: [
      {
        name: "Gardiner House",
        car: "4min",
        walking: "13min"
      },
      {
        name: "St. Mary's Church",
        car: "4min",
        walking: "10min"
      },
      {
        name: "Castle Hill Inn",
        car: "13min"
      },
      {
        name: "Downtown",
        walking: "2min"
      }
    ]
  },
  {
    name: "Wayfinder Newport",
    price: "260",
    bookBy: "2026-03-10",
    groupRate: true,
    links: {
      booking: "https://be.synxis.com/?adult=1&arrive=2026-04-24&chain=21123&child=0&currency=USD&depart=2026-04-26&group=LOWNE260424-180925&hotel=42081&level=hotel&locale=en-US&productcurrency=USD&rooms=1",
      website: "https://www.wayfindernewport.com/"
    },
    distances: [
      {
        name: "Gardiner House",
        car: "9min",
        walking: "50min"
      },
      {
        name: "St. Mary's Church",
        car: "9min",
        walking: "45min"
      },
      {
        name: "Castle Hill Inn",
        car: "17min"
      },
      {
        name: "Downtown",
        car: "10min",
        walking: "40min"
      }
    ]
  },
  {
    name: "Sonseta Select Middletown",
    price: "169",
    groupRate: true,
    links: {
      booking: "https://www.sonesta.com/sonesta-select/ri/middletown/sonesta-select-newport-middletown?isGroupCode=true&groupCode=042426LOWN_1&checkin=2026-04-24&checkout=2026-04-26",
      website: "https://www.sonesta.com/sonesta-select/ri/middletown/sonesta-select-newport-middletown"
    },
    distances: [
      {
        name: "Gardiner House",
        car: "15min"
      },
      {
        name: "St. Mary's Church",
        car: "15min"
      },
      {
        name: "Castle Hill Inn",
        car: "25min"
      },
      {
        name: "Downtown",
        car: "12min"
      }
    ]
  },
  {
    name: "Gardiner House",
    price: "995",
    groupRate: false,
    links: {
      booking: "",
      website: "https://www.gardinerhouse.com/"
    },
    distances: [
      {
        name: "Castle Hill Inn",
        car: "12min"
      },
      {
        name: "St. Mary's Church",
        car: "4min",
        walking: "8min"
      },
      {
        name: "Downtown",
        car: "6min",
        walking: "10min"
      }
    ]
  },
  {
    name: "Castle Hill Inn",
    price: "1400+",
    groupRate: false,
    links: {
      booking: "https://be.synxis.com/?adult=1&arrive=2026-04-24&chain=8565&child=0&currency=USD&depart=2026-04-26&hotel=22959&level=hotel&locale=en-US&productcurrency=USD&rooms=1",
      website: "https://www.castlehillinn.com/"
    },
    distances: [
      {
        name: "Gardiner House",
        car: "12min"
      },
      {
        name: "St. Mary's Church",
        car: "12min"
      },
      {
        name: "Downtown",
        car: "14min"
      }
    ]
  },
  {
    name: "Hammetts Hotel",
    price: "457",
    groupRate: false,
    links: {
      booking: "https://reserve.hammettshotel.com/?adult=1&arrive=2026-04-24&chain=33096&child=0&currency=USD&depart=2026-04-26&hotel=47800&level=hotel&locale=en-US&productcurrency=USD&rooms=1",
      website: "https://www.hammettshotel.com/"
    },
    distances: [
      {
        name: "Gardiner House",
        car: "2min",
        walking: "8min"
      },
      {
        name: "St. Mary's Church",
        car: "3min",
        walking: "6min"
      },
      {
        name: "Castle Hill Inn",
        car: "12min"
      },
      {
        name: "Downtown",
        car: "3min",
        walking: "4min"
      }
    ]
  }
]

const formatDate = (dateString) => {
  const date = new Date(dateString + "T00:00:00"); 
  // Adding time prevents timezone shift issues

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const Travel = () => {
  useEffect(() => {
  }, [])

  return (
    <div className="Travel">
      <Helmet>
        <title>Hotel & Travel</title>
        <meta
          name="description"
          content="Book a room in one of our hotel room blocks and see travel options for getting to Newport, RI."
        />

        <meta property="og:title" content="Hotel & Travel | Chandler & Anna" />
        <meta
          property="og:description"
          content="Book a room in one of our hotel room blocks and see travel options for getting to Newport, RI."
        />
        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/hotel_travel.jpg"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />
        <meta property="og:url" content="https://chandlerandanna.com/hotel-and-travel" />

        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className='centered-box wedding-page-block'>
        <div className='wedding-centerpiece'>
          <p className='wedding-page-title'>Hotel & Travel</p>
          <div>
            <div className='travel-list-item-links'>
              <a href="#hotels">Hotels</a>
              <a href="#getting-here">Getting Here</a>
            </div>
          </div>
          
          <div id="hotels" className="travel-container">
            <p className="travel-title">Hotels</p>
            <div className="travel-hotel-list">
              {hotels.map((hotel) => (
                <div key={hotel.name} className="travel-hotel">
                  <div className="travel-hotel-header">
                    <p className="travel-hotel-name-and-price">
                      <div className="travel-hotel-name">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-buildings-fill" viewBox="0 0 16 16">
                          <path d="M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zM2 11h1v1H2zm2 0h1v1H4zm-1 2v1H2v-1zm1 0h1v1H4zm9-10v1h-1V3zM8 5h1v1H8zm1 2v1H8V7zM8 9h1v1H8zm2 0h1v1h-1zm-1 2v1H8v-1zm1 0h1v1h-1zm3-2v1h-1V9zm-1 2h1v1h-1zm-2-4h1v1h-1zm3 0v1h-1V7zm-2-2v1h-1V5zm1 0h1v1h-1z"/>
                        </svg>
                        {hotel.name}
                      </div>
                      
                      <span className="hotel-price">${hotel.price} / night</span>
                    </p>

                    { hotel.bookBy ?
                      <p className="hotel-book-by">Book by {formatDate(hotel.bookBy)}</p>
                      :
                      <></>
                    }
                    <div className="travel-list-item-links">
                      { hotel.links.booking ?
                        <a href={hotel.links.booking} target="_blank" rel="noreferrer">
                          Link to Book
                        </a>
                        :
                        <></>
                      }
                      { hotel.groupRate == false ? <span className='list-item-links-note'>*No group rate*</span> : "" }
                      <span className="pretty-asterisk-small">*</span>
                      <a href={hotel.links.website} target="_blank" rel="noreferrer">
                        Website
                      </a>
                    </div>
                  </div>

                  {hotel.distances.map((d) => (
                    <p key={d.name}>
                      To {d.name}:{' '}
                      {d.car && (
                        <span style={{ whiteSpace: 'nowrap' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-car-front-fill" viewBox="0 0 16 16">
                            <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"/>
                          </svg>{' '}
                          {d.car}
                        </span>
                      )}

                      {d.walking && (
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {' '}
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-walking" viewBox="0 0 16 16">
                            <path d="M9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M6.44 3.752A.75.75 0 0 1 7 3.5h1.445c.742 0 1.32.643 1.243 1.38l-.43 4.083a1.8 1.8 0 0 1-.088.395l-.318.906.213.242a.8.8 0 0 1 .114.175l2 4.25a.75.75 0 1 1-1.357.638l-1.956-4.154-1.68-1.921A.75.75 0 0 1 6 8.96l.138-2.613-.435.489-.464 2.786a.75.75 0 1 1-1.48-.246l.5-3a.75.75 0 0 1 .18-.375l2-2.25Z"/>
                            <path d="M6.25 11.745v-1.418l1.204 1.375.261.524a.8.8 0 0 1-.12.231l-2.5 3.25a.75.75 0 1 1-1.19-.914zm4.22-4.215-.494-.494.205-1.843.006-.067 1.124 1.124h1.44a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.531-.22Z"/>
                          </svg>{' '}
                          {d.walking}
                        </span>
                      )}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div id="getting-here" className='travel-container'>
            <p className='travel-title'>Getting Here</p>
            <div className='getting-here-method getting-here-method-plane'>
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-airplane-fill" viewBox="0 0 16 16">
                  <path d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849"/>
                </svg>{" "}
                Fly into Boston <span className='airport-code'>(BOS)</span> or Providence <span className='airport-code'>(PVD)</span>
              </p>
              <p className='getting-here-method-info'><span className='bold'>From BOS by car (1.5 hours):</span> Drive or call an Uber from Boston to Newport, RI.</p>
              <p className='getting-here-method-info'><span className='bold'>From BOS by train (2+ hours):</span> Call an Uber to South Station <span className='bold'>(15 minutes)</span>. Take train to Kingston, RI <span className='bold'>(1 hour)</span>. Then call an Uber from Kingston to Newport <span className='bold'>(30 minutes)</span>.</p>
              <p className='getting-here-method-info'><span className='bold'>From PVD by car (35 minutes):</span> Drive or call an Uber from Providence to Newport, RI.</p>
            </div>
            <div className='getting-here-method getting-here-method-train'>
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-train-front-fill" viewBox="0 0 16 16">
                  <path d="M10.621.515C8.647.02 7.353.02 5.38.515c-.924.23-1.982.766-2.78 1.22C1.566 2.322 1 3.432 1 4.582V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V4.583c0-1.15-.565-2.26-1.6-2.849-.797-.453-1.855-.988-2.779-1.22ZM6.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m-2 2h7A1.5 1.5 0 0 1 13 5.5v2A1.5 1.5 0 0 1 11.5 9h-7A1.5 1.5 0 0 1 3 7.5v-2A1.5 1.5 0 0 1 4.5 4m.5 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2M4 5.5a.5.5 0 0 1 .5-.5h3v3h-3a.5.5 0 0 1-.5-.5zM8.5 8V5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5z"/>
                </svg>{" "}
                Train to Kingston, RI via Amtrak
              </p>
              <p className='getting-here-method-info'><span className='bold'>From Boston (1.5 hours):</span> Train from South Station (Boston) to Kingston, RI <span className='bold'>(1 hour)</span>. Then call an Uber from Kingston to Newport <span className='bold'>(30 minutes)</span>.</p>
              <p className='getting-here-method-info'><span className='bold'>From NYC (3.5 hours):</span> Train from Penn Station to Kingston, RI <span className='bold'>(3 hours)</span>. Then call an Uber from Kingston to Newport <span className='bold'>(30 minutes)</span>.</p>
            </div>
            <div className='getting-here-method'>
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-car-front-fill" viewBox="0 0 16 16">
                  <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"/>
                </svg>{" "}
                Drive to Newport
              </p>
              <p className='getting-here-method-info'><span className='bold'>From Boston (1.5 hours):</span> Take I-195 to Route 24 South, then follow RI Route 138 East to Newport.</p>
              <p className='getting-here-method-info'><span className='bold'>From NYC (3 hours):</span> Take I-95 North to US Route 1, then follow RI Route 138 East to Newport.</p>
            </div>
          </div>

        </div>
      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['seersucker-blue', 'ivory']) }
      </div>
    </div>
  );
}

export default Travel;
